import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__copyright">
        <p>
          Copyright &copy; 2024{" "}
          <a href="https://shariul.com" className="footer__link">
            Md Shariul Islam
          </a>
          . All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
